export interface CmsDirectDebitGuaranteePanel {
  directDebitGuaranteeTitle: string;
  directDebitGuaranteeLegalTerms: string;
}
